import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import { useStyles } from "./UserDrawer.css";
// import { publicImageUrl } from "../../../../../Config/publicImageUrl";
import UserMenuDrawer from "../UserMenuDrawer/UserMenuDrawer";

class UserDrawer extends Component {
  render() {
    const { classes, open } = this.props;
    return (
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          {open === true && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                fontWeight: "bold",
              }}
            >
              <div>{this.props.role} Portal</div>
              <IconButton
                onClick={this.props.handleDrawerClose}
                style={{ background: "transparent" }}
              >
                {"rtl" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton>
            </div>
          )}
        </div>

        <Divider />
        <div className={classes.scrollDraw}>
          <UserMenuDrawer open={open} role={this.props.role} />
        </div>
      </Drawer>
    );
  }
}

export default withStyles(useStyles)(UserDrawer);
